import EventHandler, { AD_EVENT, PARENT_EVENT } from "./EventHandler";
export var AD_TYPE;
(function (AD_TYPE) {
    AD_TYPE[AD_TYPE["INTERSTITIAL"] = 0] = "INTERSTITIAL";
    AD_TYPE[AD_TYPE["REWARDED"] = 1] = "REWARDED";
})(AD_TYPE || (AD_TYPE = {}));
var AdHandler = /** @class */ (function () {
    function AdHandler() {
    }
    AdHandler.getInstance = function () {
        if (!this._instance) {
            this._instance = new AdHandler();
        }
        return this._instance;
    };
    AdHandler.prototype.load = function () {
        EventHandler.getInstance().send(PARENT_EVENT.READY);
    };
    AdHandler.prototype.showAds = function (type, onReward) {
        var event;
        if (type === AD_TYPE.INTERSTITIAL) {
            event = PARENT_EVENT.AD_REQUEST;
        }
        if (type === AD_TYPE.REWARDED) {
            event = PARENT_EVENT.AD_REQUEST_REWARDED;
            EventHandler.getInstance().remove(AD_EVENT.REWARDED, undefined, true);
            EventHandler.getInstance().on(AD_EVENT.REWARDED, function () { return onReward(); }, true);
        }
        EventHandler.getInstance().send(event);
    };
    AdHandler.AD_TYPE = AD_TYPE;
    return AdHandler;
}());
export default AdHandler;
